<template>
  <div class="row">
    <template v-if="!isEmpty(customer)">
      <div class="col-md-3">
        <div class="profile-image">
          <!-- NO IMAGE -->
          <template>
            <template v-if="!customer.profile_image ||
      customer.profile_image.includes('default')
      ">
              <profile-icon :width="110" :height="110" />
            </template>
            <template v-else>
              <img :src="customer.profile_image" alt="Profile" class="profile-picture rounded-circle" />
            </template>
          </template>
        </div>
        <div class="aCenter mt-40 mb-4">
          <a href="#" v-on:click.prevent="logout()" class="sign-out">Sign Out</a>
        </div>
      </div>

      <div class="col-md-9">
        <div class="profile-info">
          <ul class="profile-info-content">
            <li>
              <div class="row">
                <div class="col-md-3 fw-bold mb-2 mb-md-0">Name</div>
                <div class="col-md-8 mb-2 mb-md-0">
                  {{ customer.firstname + " " + customer.lastname }}
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditName')"
                  v-if="webDesign !== null && webDesign.design !== null" :style="{
      color: webDesign.design.main_color + '!important',
    }">
                  Edit
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditName')" v-else>
                  Edit
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-3 fw-bold mb-2 mb-md-0">Email</div>
                <div class="col-md-8 mb-2 mb-md-0">
                  {{ customer.email }}
                  <template v-if="!customer.email_verified">
                    <small class="mt-10 d-block">
                      Please check your email at
                      {{ customer.email }} to confirm this email address
                    </small>
                    <b-button class="info-link info-link-btn" :disabled="customerIsLoading"
                      @click="resendConfirmation()" v-if="webDesign !== null && webDesign.design !== null" :style="{
      color: webDesign.design.main_color + '!important',
    }">
                      Resend Confirmation
                    </b-button>
                    <b-button class="info-link info-link-btn" :disabled="customerIsLoading"
                      @click="resendConfirmation()" v-else>
                      Resend Confirmation
                    </b-button>
                    <div v-if="hasCustomerError('message')" class="invalid-feedback d-block mt-2 mb-3">
                      <i class="bi bi-exclamation-circle text-danger mr-1" aria-hidden="true"></i>
                      {{ getCustomerError("message") }}
                    </div>
                  </template>
                </div>
                <div class="col-md-1 action d-none fw-bold" @click="view = 'edit-profile-email'"
                  v-if="webDesign !== null && webDesign.design !== null" :style="{
      color: webDesign.design.main_color + '!important',
    }">
                  Edit
                </div>
                <div class="col-md-1 action d-none fw-bold" @click="view = 'edit-profile-email'" v-else>
                  Edit
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-3 fw-bold mb-2 mb-md-0">Mobile Number</div>
                <div class="col-md-8 mb-2 mb-md-0">
                  {{ "0" + customer.mobile_number }}
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditMobileNumber')" :style="{
      color:
        webDesign && webDesign.design
          ? webDesign.design.main_color
          : null,
    }">
                  Edit
                </div>
              </div>
            </li>
            <li v-if="merchantSettings.show_key_account_field">
              <div class="row">
                <div class="col-md-3 fw-bold mb-2 mb-md-0">Key Account</div>
                <div class="col-md-4 mb-2 mb-md-0">
                  {{ customer.text1 }}
                </div>
                <div class="col-md-4">
                  <span :class="customer.company_code_status +
      '-container table-status-container text-capitalize d-inline-block'
      " style="text-align: left !important">{{ customer.company_code_status_description }}</span>
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditKeyAccount')"
                  v-if="webDesign !== null && webDesign.design !== null" :style="{
      color: webDesign.design.main_color + '!important',
    }">
                  Edit
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditKeyAccount')" v-else>
                  Edit
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-md-3 fw-bold mb-2 mb-md-0">MPIN</div>
                <div class="col-md-8 mb-2 mb-md-0">
                  <span class="pin">••••</span>
                  <p class="mt-10 d-none">Last changed Jun 20, 2020</p>
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditPIN')"
                  v-if="webDesign !== null && webDesign.design !== null" :style="{
      color: webDesign.design.main_color + '!important',
    }">
                  Edit
                </div>
                <div class="col-md-1 action fw-bold" @click="changeComponent('EditPIN')" v-else>
                  Edit
                </div>
              </div>
            </li>
            <li v-if="!estoreIsLoading">
              <b-row>
                <b-col class="text-center">
                  <b-btn variant="link" class="delete-account fw-bold" v-b-modal.delete-account-modal
                    :disabled="!canDeleteAccount">
                    Delete Account
                  </b-btn>
                  <small v-if="!canDeleteAccount" class="d-block text-muted">
                    <i class="bi bi-exclamation-circle mr-1" aria-hidden="true"></i>
                    Cannot delete account, you still have upcoming orders.
                  </small>
                </b-col>
              </b-row>
            </li>
          </ul>
          <b-container v-if="isSpecialDiscountEnabled" id="special-discount-section">
            <b-row>
              <b-col md="3" class="fw-bold pr-2 mb-2 mb-md-0">
                Special Discount
              </b-col>
              <b-col>
                <JumpingDotsLoader v-if="customerIsLoading" :fill="webDesign.design.main_color" />
                <template v-else>
                  <div v-for="(specialDiscount, index) in specialDiscountList" :key="index"
                    class="d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom">
                    <div class="w-100 pr-2">
                      <div>{{ specialDiscountLabel[specialDiscount.discount_type] }}</div>
                      <small class="text-muted d-block text-truncate">ID Name: {{ specialDiscount.customer_id_full_name }}</small>
                      <small class="text-muted d-block text-truncate">ID Number: {{ specialDiscount.customer_id_number }}</small>
                    </div>
                    <b-button class="delete-special-discount-trash bg-transparent p-0 border-0 shadow-none"
                      @click="deleteSpecialDiscount(specialDiscount.uuid)">
                      <TrashIcon class="cursor-pointer" />
                    </b-button>
                  </div>
                  <div v-if="specialDiscountList.length < 2" id="register-new-id" class="cursor-pointer"
                    :class="{ 'mt-4 mb-3': specialDiscountList.length }"
                    @click="$bvModal.show('upload-special-discount-id-modal')">
                    <PlusCircleIcon :fill="webDesign.design.main_color" />
                    <span class="ml-2 fw-bold" :style="{ color: webDesign.design.main_color }">Register new ID</span>
                  </div>
                </template>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </template>
    <delete-account-modal />
    <account-deleted-modal />
    <failed-delete-account-modal />
    <UploadSpecialDiscountIdModal @fetchSpecialDiscounts="getSpecialDiscountList" />
    <ConfirmDeleteSpecialDiscountIdModal @fetchSpecialDiscounts="getSpecialDiscountList" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DeleteAccountModal from "./DeleteAccountModal";
import AccountDeletedModal from "./AccountDeletedModal";
import FailedDeleteAccountModal from "./FailedDeleteAccountModal";
import ProfileIcon from "@/components//customer/ProfileIcon.vue";
import UploadSpecialDiscountIdModal from "@/components/special-discount/UploadSpecialDiscountIdModal.vue"
import TrashIcon from "@/components/icons/TrashIcon";
import PlusCircleIcon from "@/components/icons/PlusCircleIcon";
import JumpingDotsLoader from "@/components/common/JumpingDotsLoader";
import ConfirmDeleteSpecialDiscountIdModal from '@/components/special-discount/ConfirmDeleteSpecialDiscountIdModal.vue';

export default {
  components: {
    DeleteAccountModal,
    AccountDeletedModal,
    FailedDeleteAccountModal,
    ProfileIcon,
    UploadSpecialDiscountIdModal,
    ConfirmDeleteSpecialDiscountIdModal,
    TrashIcon,
    PlusCircleIcon,
    JumpingDotsLoader
  },
  data() {
    return {
      specialDiscountLabel: {
        senior: "Senior Citizen",
        pwd: "PWD"
      }
    }
  },
  computed: {
    ...mapState("customer", {
      customer: (state) => state.user,
      customerErrors: (state) => state.errors,
      customerIsLoading: (state) => state.loading,
      specialDiscountList: state => state.specialDiscountList
    }),
    ...mapState("merchant", {
      subdomain: (state) => state.subdomain,
      customerPortalToken: (state) => state.customerPortalToken,
      merchantIsLoading: (state) => state.loading,
      merchantErrors: (state) => state.errors,
      merchantSettings: (state) => state.merchantSettings,
    }),
    ...mapState("estore", {
      webDesign: (state) => state.webDesign,
      estoreIsLoading: (state) => state.loading,
      canDeleteAccount: (state) => state.deleteAccountStatus,
    }),
    ...mapState("auth", ["token"]),
    ...mapGetters("estore", ["isSpecialDiscountEnabled"]),
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    changeComponent(component) {
      this.$emit("change-component", component);
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    async resendConfirmation() {
      this.$store.dispatch("customer/resetErrors");
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          mobile_number: this.customer.mobile_number,
          email: this.customer.email,
          membership_id: "",
          action: "VERIFY_EMAIL",
        },
      };
      let _this = this;
      await this.$store.dispatch("customer/sendOtp", request).then(() => {
        if (_this.customerErrors == null) {
          _this.changeComponent("Verify");
        }
      });
    },
    async getDeleteAccountStatus() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken,
        },
      };

      await this.$store.dispatch("estore/getDeleteAccountStatus", request);
    },
    getCustomerError(field) {
      if (!this.customerErrors) return "";

      const errorField = this.customerErrors.errors[field];

      return Array.isArray(errorField) ? errorField[0] : errorField;
    },
    hasCustomerError(field) {
      if (!this.customerErrors) return false;

      return Boolean(this.customerErrors.errors[field]);
    },
    getSpecialDiscountList() {
      this.$store.dispatch(
        "customer/getSpecialDiscountList",
        {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken,
          },
          uuid: this.customer.uuid
        }
      );
    },
    deleteSpecialDiscount(uuid) {
      this.$store.state.estore.specialDiscountToDelete = uuid;
      this.$bvModal.show("confirm-delete-special-discount-modal");
    }
  },
  async created() {
    await this.getDeleteAccountStatus();
    await this.getSpecialDiscountList();
  },
};
</script>

<style lang="scss" scoped>
.table-status-container {
  padding: 5px 10px;
  border-radius: 40px;
  text-transform: capitalize;
}

.pending-container {
  color: #87929d;
  border: 1px #87929d solid;
}

.approved-container {
  color: #2f83fe;
}

.rejected-container {
  color: #ff5353;
  border: 1px #ff5353 solid;
}

.delete-account {
  color: #ff2d2d;
  text-decoration: none !important;

  &:hover {
    color: #ff2d2d;
    @extend .mainFontBold;
  }
}

#special-discount-section {
  border: 1px solid #D8DCDE;
  border-radius: 10px;
  padding: 15px 30px;
}

#register-new-id {
  font-size: 14px;
}

.delete-special-discount-trash {
  height: inherit;
}
</style>
